var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBridge1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92D22;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.2,163.6c-26-22.2-59-34.6-93.2-34.7c-34.2,0.1-67.3,12.4-93.3,34.7H0v-14.1c4.3-3.1,8.9-6.1,13.5-8.7 l1-0.6V76.1H0V65.6h200v10.5h-14.6v64.2l1,0.6c4.7,2.6,9.2,5.5,13.5,8.7v14.1H193.2z M149,125.4l1.5,0.4c7.3,2.2,14.6,4.8,21.6,7.9 l2.9,1.2V76.1H149V125.4z M25.1,135l2.9-1.2c7-3.1,14.3-5.7,21.6-7.9l1.5-0.4V76.1H25.1V135z M105.2,118.6l1.9,0.1 c9.7,0.5,19.4,1.7,28.8,3.7l2.5,0.5V76.1h-33.2V118.6z M61.5,122.8l2.5-0.5c9.5-2,19.2-3.2,28.8-3.7l1.9-0.1V76.1H61.5V122.8z  M0,46.9V36.4h200v10.5H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge1);
export default __webpack_public_path__ + "static/media/bridge1.9be0ed60be1952983d11fdc337230882.svg";
export { ForwardRef as ReactComponent };